import {
  Button,
  Center, PasswordInput,
  Space, Title
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputField, { InputFieldTypes } from "../components/input_field";
import { useAuth } from "../contexts/auth.context";
import { api } from "../services/api";

export default function Invite(){
  const { signIn } = useAuth();
  const {key} = useParams();
  const navigate = useNavigate();

  const [inviteData, setInviteData] = useState(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  React.useEffect(() => {
    if(key){
      api.get(`/auth/invite/${key}`)
      .then(({data}) => {
        setInviteData(data);
      })
      .catch(() => {
        showNotification({title: "Ops", message: "Token inválido", color: 'red'});
        navigate("/")
      })
    }
  }, [key, navigate])

  return (
    <Center style={{ width: "100vw", height: "100vh", background: `linear-gradient(to top right, #0088e6, #0088e6, #68fe70)` }}>
      <div
        style={{
          width: "40vw",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            api.post("/auth/invite/confirm", {
              uuid: key,
              password,
              name,
              phone,
            })
            .then(({data: {user}}) => {
              signIn(user, () => navigate("/", { replace: true }));
            })
            .catch(err => {
              showNotification({title: 'Ops', message: err.message, color: 'red'})
            })
          }}
        >
          {!!inviteData?.user
          ? <>
            <Title style={{color: 'white'}} order={3}>Aceitar convite para administrar a empresa {inviteData?.invite?.company?.name}?</Title>
          </>
          : <>
            <Title style={{color: 'white'}} order={3} mb="lg">Confirmar cadastro - {inviteData?.invite?.email}</Title>
            <InputField
              title="Nome"
              name='name'
              value={name}
              onChange={({name}) => setName(name)}
              type={InputFieldTypes.STRING}
              styles={{label: {color: 'white'}}}

            />
            <InputField
              title="Telefone ou celular"
              name='phone'
              value={phone}
              onChange={({phone}) => setPhone(phone)}
              type={InputFieldTypes.STRING}
              styles={{label: {color: 'white'}}}
            />
            <PasswordInput
              mt="md"
              label="Escolha sua senha"
              styles={{label: {color: 'white'}}}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <PasswordInput
              mt="md"
              label="Confirmar senha"
              styles={{label: {color: 'white'}}}
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
            />
          </>}
          <Space h="xl" />
          <Button
            type="submit"
            style={{ color: '#6a6a6a' }}
            mt="xl"
            color="white"
          >
            Aceitar
          </Button>
        </form>
      </div>
    </Center>
  );
};
